export { default as FaqFragment } from './Faq';
export { default as MetaFragment } from './Meta';
export { default as SuportTextFragment } from './SupportText';